<template>
  <section id="portfolio" class="has-text-primary">
    <h1>portfolio</h1>
    <p>This is a selection of projects I did in the past.</p>
    <template v-for="(project, index) in portfolio">
      <div class="columns"
        :class="{even: index % 2, odd: !(index % 2)}"
        v-bind:key="project.key">
        
        <!-- Because of http://jsfiddle.net/3t5dyn9e/  both containers need the background-->
        <div class="column
          is-half" 
          v-bind:key="project.key + '-image'"
          :style="{ backgroundImage: 'linear-gradient(rgba(0,0,0, .5), rgba(0,0,0,.5)), url(' + require(`@/assets/portfolio/${project.key}.png`) + ')'}">
          <div class="project-image"
            :style="{ backgroundImage: 'url(' + require(`@/assets/portfolio/${project.key}.png`) + ')'}">
          </div>
          <div class="tags-wraper">
            <template>
              <b-taglist>
                <b-tag
                  v-for="technology in project.technologies"
                  v-bind:key="technology"
                  type="is-info"
                  size="is-large"
                >{{technology}}</b-tag>
              </b-taglist>
            </template>
          </div>
        </div>
        <div class="column
          is-half
          project-description"
          v-bind:key="project.key + '-info'">
          <h3>{{project.title}}</h3>
          <p>{{project.description}}</p>
        </div>
      </div>
    </template>
  </section>
</template>
<script>
import { portfolio } from "@/data/portfolio.js";

export default {
  name: "Portfolio",
  data: () => {
    return {
      portfolio: portfolio.sort((fst, snd) => {return new Date(snd.duedate) - new Date(fst.duedate)})
    };
  }
};
</script>

<style lang="scss" scoped>
@import "~bulma/sass/utilities/mixins";

section#portfolio{
  div.columns:first-of-type {
    margin-top: $section-margin/2;
  }

  @include mobile {
    div.columns{
      margin-top: 3rem;
    }
  }

  div.columns.even {
    flex-direction: row-reverse;
  }

  div.column:first-child {
    position: relative;
    min-height: 25rem;
    overflow: hidden;
    padding: 0;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    &.clickable {
      cursor: pointer;
    }
  }


$duration: 500ms;


  div.project-image {
    background-size: contain;
    transition: $duration;
    
    height: 100%;
    background-position: center;
    background-repeat: no-repeat;
  }
  
  div.tags-wraper {
    display: flex;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;

    div.tags{
      visibility: hidden;
      flex-direction: row;
      justify-content: center;
      align-content: center;
      max-width: 65%;
      margin-left: auto;
      margin-right: auto;

      .tag {
        transform: translateY(5rem) scale(0.1);
        transition-duration: 400ms;
        transition-delay: $duration;
        transition-timing-function: ease;
      }
    }
  }


  div.column:first-child:hover {

    div.project-image {
      filter: blur(10px);
      background-size: cover;
    }

    div.tags-wraper {
      background-image: linear-gradient(rgba(0,0,0, 0.3), rgba(0,0,0, 0.3));

      div.tags{
        visibility: visible;

        .tag {
          transform: translateY(0rem);
          transform: scale(1);
        }
      }
    }
  }

  div.project-description {
    display: flex;
    flex-direction: column;
    justify-content: center;

    p {
      text-align: left;
      margin-top: 2rem;
    }
  }
}
</style>